import store from '../../store';
import Errors from '../../Errors';
import ProductRating from '../ProductRating.vue';
import ProductCardMixin from '../../mixins/ProductCardMixin';
import RelatedProducts from './show/RelatedProducts.vue';

export default {
    components: { ProductRating, RelatedProducts },

    mixins: [
        ProductCardMixin,
    ],

    props: [
        'flashSaleOptionValues', 'isInFlashSale', 'product', 'reviewCount',
        'avgRating', 'outOfStock', 'inStock', 'buttonStatus', 'productQty',
        'prodPrice', 'inStockTrans', 'outStockTrans', 'finalPrice',
        'outStockVariations', 'inStockVariations', 'optionsIds'
    ],

    data() {
        return {
            price: this.prodPrice,
            scalaPayPrice: this.finalPrice,
            activeTab: 'description',
            currentReviewPage: 1,
            fetchingReviews: false,
            reviews: {},
            addingNewReview: false,
            reviewForm: {},
            cartItemForm: {
                product_id: this.product.id,
                qty: 1,
                options: {},
                is_flash_product: this.isInFlashSale,
                flash_sale_option_variation: this.flashSaleOptionValues
            },
            errors: new Errors(),
            cartBtnStatus: this.buttonStatus,
            stockStatus: this.inStock,
            prodcutMaxQty: this.productQty,
            optionTypes: {
                colorOptions: null,
                capacityOptions: null,
                gradeOptions: null,
            },
            optionValueTypes: {},
            analyzedOptions: false,
            colorMap: [
                'Nero Opaco',
                'Oro Rosa',
                'Viola scuro',
                'Oro',
                'Argento',
                'Nero siderale',
                'Blu',
                'Mezzanotte',
                'Viola',
                'Galassia',
                'Giallo',
                'Grigio Siderale',
                'Rosso',
                'Bianco',
                'Corallo',
                'Nero',
                'Verde Alpino',
                'Azzurro Sierra',
                'Grafite',
                'Verde Notte',
                'Verde',
                'Rosa',
                'Blu Pacifico',
            ],
            knownGrades: ['A', 'B', 'C', 'A/B', 'AB'],
        };
    },

    computed: {
        allAvailableOptions() {
            const values = new Set();
            this.inStockVariations.forEach(variation => {
                variation.combination.forEach(c => {
                    values.add(c.option_combination);
                });
            });
            return Array.from(values);
        },

        totalReviews() {
            if (!this.reviews.total) {
                return this.reviewCount;
            }
            return this.reviews.total;
        },

        ratingPercent() {
            return (this.avgRating / 5) * 100;
        },

        emptyReviews() {
            return this.totalReviews === 0;
        },

        totalReviewPage() {
            return Math.ceil(this.reviews.total / 4);
        },

        currentColor() {
            if (!this.optionTypes.colorOptions) return null;
            return this.cartItemForm.options[this.optionTypes.colorOptions];
        },
        currentCapacity() {
            if (!this.optionTypes.capacityOptions) return null;
            return this.cartItemForm.options[this.optionTypes.capacityOptions];
        },
        currentGrade() {
            if (!this.optionTypes.gradeOptions) return null;
            return this.cartItemForm.options[this.optionTypes.gradeOptions];
        },
    },

    created() {
        this.fetchReviews();
    },

    mounted() {
        $(this.$refs.upSellProducts).slick({
            rows: 0,
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            rtl: window.FleetCart.rtl,
        });
        this.analyzeProductOptions();
        this.selectFirstAvailableOptions();
    },

    methods: {
        getOptionType(optionId) {
            if (this.optionTypes.colorOptions === optionId) {
                return 'color';
            } else if (this.optionTypes.capacityOptions === optionId) {
                return 'capacity';
            } else if (this.optionTypes.gradeOptions === optionId) {
                return 'grade';
            }
            return null;
        },

        analyzeProductOptions() {
            if (this.analyzedOptions) return;
            this.analyzedOptions = true;

            let allOptions = new Map();
            this.inStockVariations.forEach(variation => {
                variation.combination.forEach(combo => {
                    if (!allOptions.has(combo.labels.option_id)) {
                        allOptions.set(combo.labels.option_id, {
                            id: combo.labels.option_id,
                            values: [],
                            samples: []
                        });
                    }
                    const optionData = allOptions.get(combo.labels.option_id);
                    if (!optionData.values.some(v => v.id === combo.option_combination)) {
                        optionData.values.push({
                            id: combo.option_combination,
                            label: combo.labels.label
                        });
                        optionData.samples.push(combo.labels.label);
                    }
                });
            });

            allOptions.forEach((option, optionId) => {
                if (option.samples.some(label => /^\d+(?:GB|TB)$/i.test(label.trim()))) {
                    this.optionTypes.capacityOptions = optionId;
                }
                else if (option.samples.some(label => this.knownGrades.includes(label.trim()))) {
                    this.optionTypes.gradeOptions = optionId;
                }
                else if (option.samples.some(label => Object.keys(this.colorMap).includes(label.trim()))) {
                    this.optionTypes.colorOptions = optionId;
                }
                else {
                    const firstValue = option.samples[0].toLowerCase() || '';

                    if (!this.optionTypes.colorOptions &&
                        (Object.keys(this.colorMap).some(color =>
                            firstValue.includes(color.toLowerCase())) ||
                         /colou?r|black|white|blue|red|green|yellow|purple|silver|gold/i.test(firstValue))) {
                        this.optionTypes.colorOptions = optionId;
                    }
                    else if (!this.optionTypes.capacityOptions &&
                             /capacity|\dgb|\dtb|\dmb/i.test(firstValue)) {
                        this.optionTypes.capacityOptions = optionId;
                    }
                    else if (!this.optionTypes.gradeOptions &&
                             /grade|condition|quality|a\/?b|b\/?c/i.test(firstValue)) {
                        this.optionTypes.gradeOptions = optionId;
                    }
                }
            });
        },

        updateQuantity(qty) {
            if (qty < 1 || this.exceedsMaxStock(qty)) {
                return;
            }

            if (isNaN(qty)) {
                qty = 1;
            }

            this.cartItemForm.qty = qty;
        },

        exceedsMaxStock(qty) {
            return this.product.manage_stock && this.prodcutMaxQty < qty;
        },

        changeReviewPage(page) {
            this.currentReviewPage = page;
            this.fetchReviews();
        },

        filterCombinations(selectedOptions, inStockOptions) {
            return inStockOptions.filter(option => {
                if (selectedOptions[1] !== undefined && option[1] !== selectedOptions[1]) {
                    return false;
                }
                return option.reduce((prev, curr, i) =>
                    prev && (selectedOptions[i] === curr || selectedOptions[i] === undefined), true
                );
            });
        },

        shoudDisableOption(selfValue, optionId) {
            // Controllo iniziale se non ci sono optionTypes o capacità
            if (!this.optionTypes || !this.currentCapacity) {
                return !this.allAvailableOptions.includes(selfValue);
            }

            if (this.currentCapacity) {
                // Colore
                if (optionId === this.optionTypes.colorOptions) {
                    const validOptions = [];

                    this.inStockVariations.forEach(variation => {
                        // Verifica capacità
                        const hasCapacity = variation.combination.some(combo =>
                            combo.labels.option_id === this.optionTypes.capacityOptions &&
                            combo.option_combination === this.currentCapacity
                        );

                        // Verifica grado
                        const hasGrade = !this.currentGrade || variation.combination.some(combo =>
                            combo.labels.option_id === this.optionTypes.gradeOptions &&
                            combo.option_combination === this.currentGrade
                        );
                        if (hasCapacity && hasGrade) {
                            variation.combination.forEach(combo => {
                                if (combo.labels.option_id === optionId) {
                                    validOptions.push(combo.option_combination);
                                }
                            });
                        }
                    });

                    return !validOptions.includes(selfValue);
                }

                // Grado
                if (optionId === this.optionTypes.gradeOptions) {
                    const validOptions = [];

                    this.inStockVariations.forEach(variation => {
                        const hasCapacity = variation.combination.some(combo =>
                            combo.labels.option_id === this.optionTypes.capacityOptions &&
                            combo.option_combination === this.currentCapacity
                        );

                        if (hasCapacity) {
                            variation.combination.forEach(combo => {
                                if (combo.labels.option_id === optionId) {
                                    validOptions.push(combo.option_combination);
                                }
                            });
                        }
                    });

                    return !validOptions.includes(selfValue);
                }

                // Capacità
                if (optionId === this.optionTypes.capacityOptions) {
                    return !this.inStockVariations.some(variation =>
                        variation.combination.some(combo =>
                            combo.labels.option_id === optionId &&
                            combo.option_combination === selfValue
                        )
                    );
                }

                // Per qualsiasi altra opzione
                const validOptions = [];
                this.inStockVariations.forEach(variation => {
                    const hasCapacity = variation.combination.some(combo =>
                        combo.labels.option_id === this.optionTypes.capacityOptions &&
                        combo.option_combination === this.currentCapacity
                    );

                    // Considera il grado se è stato selezionato
                    const hasGrade = !this.currentGrade || variation.combination.some(combo =>
                        combo.labels.option_id === this.optionTypes.gradeOptions &&
                        combo.option_combination === this.currentGrade
                    );

                    if (hasCapacity && hasGrade) {
                        variation.combination.forEach(combo => {
                            if (combo.labels.option_id === optionId) {
                                validOptions.push(combo.option_combination);
                            }
                        });
                    }
                });

                return !validOptions.includes(selfValue);
            }

            return !this.allAvailableOptions.includes(selfValue);
        },

        updatePrice() {
            this.$nextTick(() => {
                this.cartBtnStatus = true;
                $.ajax({
                    method: 'POST',
                    url: route('products.price.show', { id: this.product.id }),
                    data: {
                        options: this.cartItemForm.options,
                        flash_sale_id: this.isInFlashSale,
                        flash_sale_option: this.flashSaleOptionValues
                    },
                }).then((response) => {
                    this.price = response.price;
                    this.cartItemForm.qty = 1;
                    $('.btn-number.btn-minus').removeAttr('disabled');
                    $('.btn-number.btn-plus').removeAttr('disabled');
                    this.scalaPayPrice = response.finalPrice;
                    this.stockStatus = response.stock_status ? this.inStockTrans : this.outStockTrans;
                    this.prodcutMaxQty = response.qty;
                    this.cartBtnStatus = response.buttonStatus;
                }).catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                });
            });
        },

        updateSelectTypeOptionValue(optionId, e) {
            if (!$(e.target).val())
                delete this.cartItemForm.options[optionId];
            else
                this.$set(this.cartItemForm.options, optionId, $(e.target).val());

            this.errors.clear(`options.${optionId}`);
        },

        updateCheckboxTypeOptionValue(optionId, e) {
            let values = $(e.target)
                .parents('.variant-check')
                .find('input[type="checkbox"]:checked')
                .map((_, el) => el.value);
            this.$set(this.cartItemForm.options, optionId, values.get());
        },

        customRadioTypeOptionValueIsActive(optionId, valueId) {
            if (!this.cartItemForm.options.hasOwnProperty(optionId)) {
                return false;
            }
            return this.cartItemForm.options[optionId] === valueId;
        },

        isCurrentCombinationValid() {
            return this.inStockVariations.some(variation => {
                return this.optionsIds.every(id => {
                    return variation.combination.find(c =>
                        c.labels.option_id === id &&
                        c.option_combination === this.cartItemForm.options[id]
                    );
                });
            });
        },

        adjustCombination(changedOptionId) {
            if (this.isCurrentCombinationValid()) return;

            const validVariation = this.inStockVariations.find(variation => {
                return variation.combination.some(c =>
                    c.labels.option_id === changedOptionId &&
                    c.option_combination === this.cartItemForm.options[changedOptionId]
                );
            });

            if (validVariation) {
                validVariation.combination.forEach(c => {
                    const optionSelector = `li[data-option-id="${c.labels.option_id}"][data-value-id="${c.option_combination}"]`;
                    const element = document.querySelector(optionSelector);
                    if (element) {
                        element.click();
                    } else {
                        this.$set(this.cartItemForm.options, c.labels.option_id, c.option_combination);
                    }
                });
            }
        },

        syncCustomRadioTypeOptionValue(optionId, valueId) {
            if (!this.customRadioTypeOptionValueIsActive(optionId, valueId)) {
                this.$set(this.cartItemForm.options, optionId, valueId);
                this.errors.clear(`options.${optionId}`);
                this.adjustCombination(optionId);
            }
            this.updatePrice();
        },

        descriptionshows(gradeList, grade) {
            let entries = Object.entries(gradeList);
            entries.map(([key, val] = entry) => {
                if (key == grade) {
                    document.getElementById("grade_description").innerHTML = val;
                }
            });
        },

        descriptionbattery(descList, name) {
            let entries = Object.entries(descList);
            entries.map(([key, val] = entry) => {
                if (key == name) {
                    document.getElementById("battry_description").innerHTML = val;
                }
            });
        },

        customCheckboxTypeOptionValueIsActive(optionId, valueId) {
            if (!this.cartItemForm.options.hasOwnProperty(optionId)) {
                this.$set(this.cartItemForm.options, optionId, []);
                return false;
            }
            return this.cartItemForm.options[optionId].includes(valueId);
        },

        syncCustomCheckboxTypeOptionValue(optionId, valueId) {
            if (this.customCheckboxTypeOptionValueIsActive(optionId, valueId)) {
                this.cartItemForm.options[optionId].splice(
                    this.cartItemForm.options[optionId].indexOf(valueId),
                    1
                );
            } else {
                this.cartItemForm.options[optionId].push(valueId);
                this.errors.clear(`options.${optionId}`);
            }
            this.updatePrice();
        },

        fetchReviews() {
            this.fetchingReviews = true;
            $.ajax({
                method: 'GET',
                url: route('products.reviews.index', {
                    productId: this.product.id,
                    page: this.currentReviewPage,
                }),
            }).then((reviews) => {
                this.reviews = reviews;
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.fetchingReviews = false;
            });
        },

        addNewReview() {
            this.addingNewReview = true;
            $.ajax({
                method: 'POST',
                url: route('products.reviews.store', { productId: this.product.id }),
                data: this.reviewForm,
            }).then((review) => {
                this.reviewForm = {};
                this.reviews.total++;
                this.reviews.data.unshift(review);
                $('.captcha-input').prev('img').trigger('click');
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                } else {
                    this.$notify(xhr.responseJSON.message);
                }
            }).always(() => {
                this.addingNewReview = false;
            });
        },

        addToCart() {
            this.addingToCart = true;
            $.ajax({
                method: 'POST',
                url: route('cart.items.store', this.cartItemForm),
            }).then((cart) => {
                store.updateCart(cart);
                $('.header-cart').trigger('click');
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                } else {
                    this.$notify(xhr.responseJSON.message);
                }
            }).always(() => {
                this.addingToCart = false;
            });
        },

        selectFirstAvailableOptions() {
            this.$nextTick(() => {
                const groups = document.querySelectorAll(".custom-selection");
                groups.forEach(group => {
                    const activeOption = group.querySelector("li.active");
                    if (!activeOption) {
                        const availableOptions = group.querySelectorAll("li:not(.disabled)");
                        if (availableOptions.length) {
                            availableOptions[0].click();
                        }
                    }
                });
            });
        },
    },
};